import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router';
import { ButtonMain } from '../../../atoms';
import { RootState } from '../../../redux/root';
import { setActiveTab } from '../../../redux/slices/wikiSlice';

const JurisdictionTabs = () => {
  const { activeTab, wikiMode } = useSelector((s: RootState) => s.wikiSlice);
  const dispatch = useDispatch();
  const { wikiId } = useParams();

  const onClick = who => {
    if (who === activeTab) {
      dispatch(setActiveTab('None'));
      return;
    }
    dispatch(setActiveTab(who));
  };
  const isDisabled = () => {
    if (wikiId === undefined) {
      return true;
    }
    if (wikiMode === 'JURI') {
      return false;
    }

    return true;
  };
  return (
    <Wrapper>
      {!isDisabled() && <First>
        <ButtonMain variant={activeTab === 'None' ? 'contained' : 'text'} onClick={() => dispatch(setActiveTab('None'))}>
          Details
        </ButtonMain>
        <ButtonMain variant={activeTab === 'P' ? 'contained' : 'text'} onClick={e => onClick('P')}>
          Permitting
        </ButtonMain>
        <ButtonMain variant={activeTab === 'I' ? 'contained' : 'text'} onClick={e => onClick('I')}>
          Inspections
        </ButtonMain>
        <ButtonMain variant={activeTab === 'N' ? 'contained' : 'text'} onClick={e => onClick('N')}>
          Notes
        </ButtonMain>
      </First>}
    </Wrapper>
  );
};

export default JurisdictionTabs;

const Wrapper = styled.div`
  display: flex;
  width: 100%;
  margin: 0 0 16px;
`;

const First = styled.div`
  display: flex;
  flex: 1;
  gap: 4px;
  background: var(--neutral-100);
  border: 1px solid var(--border);
  border-radius: 12px;
  padding: 4px;
  box-sizing: border-box;

  button {
    flex: 1;
    height: 40px;
    border-radius: 8px;
    font-weight: 600;
    text-transform: none;
    font-size: 0.875rem;
    letter-spacing: 0.01em;
  }
`;
